// ClientRoutesWithDash.js (routes avec sidebar)

import DashboardPage from '../views/clientviews/Dashboardclient'; // Page Dashboard
import PatientList from '../views/clientviews/Patientmanagment/patientlist'; // Page Patient Management
import Speciality from '../views/clientviews/speciality'; // Page Patient Management
import StaffList from '../views/clientviews/staffmanagment/stafflist'; // Page Patient Management
import NewAppointment from '../views/clientviews/appointmentmanagment/addappointment'; // Page Patient Management
import Patientfilemedical from '../views/clientviews/Patientmanagment/patientmedicalfile'; // Page Patient Management
import Medicalhistory from '../views/clientviews/Patientmanagment/patientmedicalhistory'; // Page Patient Management
import PaymentCaisse from '../views/clientviews/billingmanagement/payment'; // Page Patient Management
import ReceiptPayment from '../views/clientviews/billingmanagement/receipt'; // Page Patient Management
import Department from '../views/clientviews/deparmentmanagment/department'; // Page Patient Management
import HospitalSetting from '../views/hospitalsetting'; // Page Patient Management
import PatientCard from '../views/clientviews/Patientmanagment/patientcard'; // Page Patient Management
import Appointments from '../views/Doctorinterface/appointment.js';
import AppointmentHistory from '../views/Doctorinterface/appointement_history.js';
import MedicalAppointments from '../views/Doctorinterface/patientDetail.js';
import CalendarWeekView from '../views/Doctorinterface/calendar.js';
import StaffDetails from '../views/clientviews/staffmanagment/user'; // Page Patient Management
import StaffSchedule from '../views/clientviews/staffmanagment/horaire'; // Page Patient Management
import StaffScheduleEdit from '../views/clientviews/staffmanagment/horaireedit'; // Page Patient Management
import telMed from '../views/clientviews/telemedecine/tele'; // Page Patient Management
// Ordonnance
import Ordonnance from '../views/clientviews/telemedecine/appointment/ordornance'; // Page Patient Management
import Appoint from '../views/clientviews/telemedecine/appointment/appoint'; // Page Patient Management


// apointment manage
import Appointmentprocess from '../views/clientviews/appointmentmanagment/appointment'; // Page Patient Management
import Doctoragenda from '../views/clientviews/appointmentmanagment/timetable'; // Page Patient Management
import Patientdontknow from '../views/clientviews/appointmentmanagment/patient'; // Page Patient Management
import Schedulerdv from '../views/clientviews/appointmentmanagment/schedulerdv'; // Page Patient Management
import Editappointment from '../views/clientviews/appointmentmanagment/editappointment.js'

// room managment
import RoomsList from '../views/roomManagment/roomList';

// nurses appointment liste
import AppointmentlistNurses from '../views/clientviews/appointmentmanagment/appointmentlist'; // Page Patient Management
import SignvitalForm from '../views/clientviews/appointmentmanagment/Signvital'; // Page Patient Management


// Dr Functionnalities
import DoctorDashboard from '../views/Doctorinterface/dashboard.js'; // Page Patient Management
import DoctorPatientDetails from '../views/Doctorinterface/patientDetail.js'; // Page Patient Management
import DoctorCalendar from '../views/Doctorinterface/calendar.js'; // Page Patient Management
import DoctorAppointment from '../views/Doctorinterface/appointment.js'; // Page Patient Management
import DoctorHistory from '../views/Doctorinterface/appointement_history.js'; // Page Patient Management
import DoctorIntakeConsult from '../views/new/docteur.js'; // Page Patient Management
import Consultaiondetails from '../views/new/consultationdetails.js'; // Page Patient Management



import Infirmier from '../views/new/infirmier';
import Docteur from '../views/new/docteur'

// billings
import Paymentlist from '../views/clientviews/billingmanagement/allpaymentlist'; // Page Patient Management
import InvoiceAssurance from '../views/clientviews/billingmanagement/caisiere/culture'; // Page Patient Management

// hospital setting
import Generalcongig from '../views/Hospitalconfiguration/generalconfig'; // Page Patient Management
import HospitalDashboard from '../views/Rapport/repport.js';


const ClientRoutesWithDash = [
  { path: '/hospitaladmin/dashboard', name: 'Dashboard', element: DashboardPage },
  { path: '/hospitaladmin/patientlist', name: 'Patient Management', element: PatientList },
  { path: '/hospitaladmin/patientfilemedical/:patientId', name: 'patientfilemedical', element: Patientfilemedical , exact: true },
  { path: '/hospitaladmin/department', name: 'department', element: Department , exact: true },
  { path: '/hospitaladmin/speciality', name: 'Speciality', element: Speciality , exact: true },
  { path: '/hospitaladmin/speciality', name: 'Speciality', element: Speciality , exact: true },
  { path: '/hospitaladmin/stafflist', name: 'StaffList', element: StaffList , exact: true },
  { path: '/hospitaladmin/addappointment', name: 'NewAppointment', element: NewAppointment , exact: true },
  { path: '/hospitaladmin/medicalhistory', name: 'Medicalhistory', element: Medicalhistory , exact: true },
  { path: '/hospitaladmin/payment', name: 'PaymentCaisse', element: PaymentCaisse },
  { path: '/hospitaladmin/receiptpay', name: 'ReceiptPayment', element: ReceiptPayment },
  { path: '/hospitaladmin/hospitalsetting', name: 'HospitalSetting', element: HospitalSetting },
  { path: '/patientcard/:patientId', name: 'PatientCard', element: PatientCard },
  { path: '/hospitaladmin/appointment', name: 'Appointment', element: Appointments },
  { path: '/hospitaladmin/appointment_history', name: 'AppointmentHistory', element: AppointmentHistory },
  { path: '/hospitaladmin/patient_details', name: 'PatientDetail', element: MedicalAppointments },
  { path: '/hospitaladmin/appoint_calendar', name: 'AppointCalendar', element: CalendarWeekView },
  { path: '/hospitaladmin/staff_details', name: 'StaffDetails', element: StaffDetails },
  { path: '/hospitaladmin/staff_schedule', name: 'StaffSchedule', element: StaffSchedule },
  { path: '/hospitaladmin/staff_schedule_edit', name: 'StaffSchedule', element: StaffScheduleEdit },
  { path: '/hospitaladmin/telemedecine', name: 'StaffSchedule', element: telMed },
  { path: '/hospitaladmin/telemedecine/:meetingCode', name: 'TelemedicineCall', element: telMed },


  // Ordonnance
  { path: '/hospitaladmin/telemedecine/ordornance', name: 'Ordonnance', element: Ordonnance },
  { path: '/hospitaladmin/telemedecine/ordornance/:consultationId', name: 'Ordonnance', element: Ordonnance },
  { path: '/hospitaladmin/telemedecine/appoint', name: 'Appoint', element: Appoint },

  // Appointment
  { path: '/hospitaladmin/appointmentprocess', name: 'Appointmentprocess', element: Appointmentprocess },
  { path: '/hospitaladmin/doctoragenda', name: 'Doctoragenda', element: Doctoragenda },
  { path: '/hospitaladmin/patientdontknow', name: 'Patientdontknow', element: Patientdontknow },
  { path: '/hospitaladmin/schedulerdv', name: 'Schedulerdv', element: Schedulerdv },
  { path: '/hospitaladmin/editappointment/:id', name: 'Editappointment', element: Editappointment },


  // nurses appointment liste
  { path: '/hospitaladmin/Appointmentlist', name: 'AppointmentlistNurses', element: AppointmentlistNurses },
  { path: '/appointment/:appointmentId/signvital', name: 'SignvitalForm', element: SignvitalForm },


  // Doctor
  { path: '/hospitaladmin/doctor/overviews', name: 'Overviews', element: DoctorDashboard },
  { path: '/hospitaladmin/doctor/patientdetail', name: 'Patientdetail', element: DoctorPatientDetails },
  { path: '/hospitaladmin/doctor/calendar/:doctorId', name: 'Calendar', element: DoctorCalendar },
  { path: '/hospitaladmin/doctor/appointment', name: 'Appointment', element: DoctorAppointment },
  { path: '/hospitaladmin/doctor/appointement_history', name: 'Appointement_history', element: DoctorHistory },
  { path: '/infirmier', name: 'Infirmier', element: Infirmier },
  { path: '/docteur', name: 'Docteur', element: Docteur },
  { path: '/hospitaladmin/intakeformconsult', name: 'intake form', element: DoctorIntakeConsult },
  { path: '/hospitaladmin/consultation-details/:consultationId', name: 'details', element: Consultaiondetails },

  { path: '/report', name: 'Report', element: HospitalDashboard },


  // Room managment
  { path: '/hospitaladmin/rooms_list', name: 'RoomsList', element: RoomsList },

  // hospita setting
  { path: '/hospitaladmin/generalconfig', name: 'Generalcongig', element: Generalcongig },

  // billing
  { path: '/Billings/allpaymentlist', name: 'Paymentlist', element: Paymentlist },
  { path: '/Billings/invoiceAssurance/:billingID', name: 'InvoiceAssurance', element: InvoiceAssurance },




  // Ajoutez ici d'autres routes qui nécessitent un sidebar
];

export default ClientRoutesWithDash;

